/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var ErrorMessage_1 = require("./ErrorMessage");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ToggleButton.css'); }
var cssBaseClass = "m-toggleButton";
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory(cssBaseClass);
var BLOCKED_SHAKING_DURATION = 650;
var ToggleButton = /** @class */ (function (_super) {
    tslib_1.__extends(ToggleButton, _super);
    function ToggleButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggle = _this.onToggle.bind(_this);
        _this.state = {
            shaking: false
        };
        return _this;
    }
    ToggleButton.prototype.componentWillUnmount = function () {
        if (this.shakeTimeout) {
            clearTimeout(this.shakeTimeout);
        }
    };
    ToggleButton.prototype.onToggle = function (event) {
        event.preventDefault();
        if (this.props.blocked) {
            this.shake();
            return;
        }
        this.props.onChange(event, !this.props.value);
    };
    ToggleButton.prototype.shake = function () {
        var _this = this;
        this.setState({ shaking: true });
        this.shakeTimeout = window.setTimeout(function () {
            _this.setState({ shaking: false });
        }, BLOCKED_SHAKING_DURATION);
    };
    ToggleButton.prototype.render = function () {
        var _a;
        var _b = this.props, errorMessage = _b.errorMessage, hasWarning = _b.hasWarning, label = _b.label, children = _b.children, _c = _b.falseLabel, falseLabel = _c === void 0 ? "No" : _c, _d = _b.trueLabel, trueLabel = _d === void 0 ? "Yes" : _d, _e = _b.blocked, blocked = _e === void 0 ? false : _e, _f = _b.decision, decision = _f === void 0 ? false : _f, _g = _b.compact, compact = _g === void 0 ? false : _g, _h = _b.value, value = _h === void 0 ? false : _h, name = _b.name;
        var shaking = this.state.shaking;
        var labelId = name + "-toggle-label";
        var mainClassesName = (_a = {},
            _a[cssBaseClass] = true,
            _a[moduleClassName()] = true,
            _a[moduleClassName(name)] = true,
            _a[moduleClassName("isShaking")] = this.state.shaking,
            _a[moduleClassName("isBlocked")] = blocked,
            _a[moduleClassName("isDecision")] = decision,
            _a[moduleClassName("isCompact")] = compact,
            _a[moduleClassName("hasWarning")] = !!hasWarning,
            _a[moduleClassName("isActive")] = value,
            _a);
        return (React.createElement("div", { className: classnames(mainClassesName) },
            React.createElement("button", { name: name, className: cssBaseClass + "-input", onClick: this.onToggle, type: "button", "aria-pressed": value, "aria-labelledby": labelId },
                React.createElement("div", { className: cssBaseClass + "-option " + cssBaseClass + "-option-isFalse" }, falseLabel),
                React.createElement("div", { className: cssBaseClass + "-option " + cssBaseClass + "-option-isTrue" }, trueLabel),
                React.createElement("div", { className: cssBaseClass + "-switch" })),
            React.createElement("span", { className: cssBaseClass + "-label", id: labelId }, !!children ? children : label),
            errorMessage && React.createElement(ErrorMessage_1.ErrorMessage, { isLarge: true }, errorMessage)));
    };
    ToggleButton.propTypes = {
        value: PropTypes.bool,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        trueLabel: PropTypes.string,
        falseLabel: PropTypes.string,
        compact: PropTypes.bool,
        decision: PropTypes.bool,
        blocked: PropTypes.bool,
        errorMessage: PropTypes.string,
        hasWarning: PropTypes.bool,
        /* Todo: deprecate usage of label. children are recommended */
        label: PropTypes.node
    };
    ToggleButton.defaultProps = {
        value: false,
        blocked: false,
        decision: false,
        compact: false,
        trueLabel: "Yes",
        falseLabel: "No"
    };
    return ToggleButton;
}(React.Component));
exports.ToggleButton = ToggleButton;